import { Component, Input, OnInit } from "@angular/core";
import { forkJoin } from "rxjs";
import { finalize } from "rxjs/operators";
import { AlertService } from "@modules/alert";
import {
  EburyClient,
  EburyClientMappingShow,
  EburyService,
} from "src/app/_services/ebury.service";
import { LoadingTypeEnum } from "../../shared/_enums/loading-type.enum";

@Component({
  selector: "app-company-ebury-mapping",
  templateUrl: "./company-ebury-mapping.component.html",
  styleUrls: ["./company-ebury-mapping.component.scss"],
  standalone: false,
})
export class CompanyEburyMappingComponent implements OnInit {
  @Input() entityId: number;

  public isLoading = false;
  public isSaving = false;

  public eburyClients: EburyClient[] = [];
  public mappingData: EburyClientMappingShow | null = null;
  public selectedEburyClientId: string | null = null;
  private originalEburyClientId: string | null = null;

  constructor(
    private eburyService: EburyService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  public get hasChanged(): boolean {
    return this.selectedEburyClientId !== this.originalEburyClientId;
  }

  public get canSave(): boolean {
    return this.hasChanged;
  }

  public loadData(): void {
    this.isLoading = true;

    forkJoin({
      mapping: this.eburyService.getClientMapping(this.entityId),
      clients: this.eburyService.getClients(),
    })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: ({ mapping, clients }) => {
          this.mappingData = mapping.result ?? null;
          this.eburyClients = clients.result ?? [];

          this.selectedEburyClientId =
            this.mappingData?.mapping?.ebury_client_id ?? null;
          this.originalEburyClientId = this.selectedEburyClientId;
        },
        error: () => {
          this.mappingData = null;
        },
      });
  }

  public save(): void {
    if (!this.canSave || this.isSaving) {
      return;
    }

    this.isSaving = true;

    this.eburyService
      .upsertClientMapping(this.entityId, this.selectedEburyClientId)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe({
        next: () => {
          this.alertService.saved();
          this.loadData();
        },
        error: (err) => this.handleError(err),
      });
  }

  private handleError(err: any): void {
    if (err?.error?.message) {
      this.alertService.stringError(err.error.message);
    } else {
      this.alertService.errors(err?.error?.errors);
    }
  }

  get LoadingType() {
    return LoadingTypeEnum;
  }
}
